import * as types from '../actions/actionTypes'
// import { shouldShowAddButton } from '../actions/appBarActions';


const appBarReducer = (state = {
  shouldShowSearchBar: false,
  searchWord: "",
  title: "",
}, action) => {

    switch(action.type) {
      case types.SHOULD_SHOW_SEARCH_BAR: 
      state = {
        ...state,
        shouldShowSearchBar: action.payload,
        searchWord: ""
      };
      break;
      case types.UPDATE_SEARCH_WORD: 
      state = {
        ...state,
        searchWord: action.payload,
      };
      break;
      case types.UPDATE_TITLE: 
      state = {
        ...state,
        title: action.payload,
      };
      break;
      
      default:
      break;    
    }
    
    return state;
};


export default appBarReducer;


// WEBPACK FOOTER //
// ./src/reducers/appBarReducer.js